import { ChangeDetectionStrategy, Component, computed, OnDestroy, OnInit, signal } from '@angular/core';
import { NgClass } from '@angular/common';

interface ProvisionStep {
  id: number;
  label: string;
  desc: string;
}

@Component({
  selector: 'app-mksoft-onboarding',
  imports: [NgClass],
  templateUrl: './onboarding.html',
  styleUrl: './onboarding.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Onboarding implements OnInit, OnDestroy {
  readonly currentStep = signal(1);
  private timer: ReturnType<typeof setInterval> | null = null;

  readonly provisionSteps: ProvisionStep[] = [
    { id: 1, label: 'Betrieb wird angelegt', desc: 'Mandant in der Datenbank erstellen' },
    { id: 2, label: 'Benutzer verknüpfen', desc: 'Account wird dem Betrieb zugeordnet' },
    { id: 3, label: 'Starter-Plan aktivieren', desc: 'Kostenloser Plan wird freigeschaltet' },
    { id: 4, label: 'Abgeschlossen', desc: 'Bereit für dein erstes Schaf' },
  ];

  readonly progressPct = computed(() => {
    const map: Record<number, number> = { 1: 15, 2: 45, 3: 75, 4: 100 };
    return map[this.currentStep()] ?? 15;
  });

  readonly stepTitle = computed(() => {
    const map: Record<number, string> = {
      1: 'Betrieb wird eingerichtet…',
      2: 'Benutzer wird verknüpft…',
      3: 'Plan wird aktiviert…',
      4: 'Alles bereit!',
    };
    return map[this.currentStep()] ?? '';
  });

  readonly stepSubtitle = computed(() => {
    const map: Record<number, string> = {
      1: 'Wir richten deinen SmartSheep-Betrieb ein. Das dauert einen Moment.',
      2: 'Dein Account wird dem Betrieb zugeordnet.',
      3: 'Dein kostenloser Starter-Plan wird freigeschaltet.',
      4: "Dein Betrieb ist eingerichtet. Gleich geht's weiter…",
    };
    return map[this.currentStep()] ?? '';
  });

  ngOnInit() {
    const delays = [8000, 12000, 15000];
    delays.forEach((delay, index) => {
      setTimeout(() => this.currentStep.set(index + 2), delay);
    });
  }

  ngOnDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }
}
